export const LinkIcon = ({ className, color = "currentColor" }: { className?: string; color?: string }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.83333 9.16669C7.12171 9.55359 7.49001 9.87396 7.91324 10.1063C8.33647 10.3387 8.80461 10.4778 9.28628 10.5142C9.76795 10.5506 10.2516 10.4836 10.7044 10.3178C11.1572 10.152 11.5686 9.89131 11.9107 9.55335L13.9107 7.55335C14.5276 6.91433 14.8695 6.05818 14.8614 5.16878C14.8533 4.27938 14.4959 3.42961 13.8676 2.80133C13.2393 2.17305 12.3896 1.81565 11.5002 1.80754C10.6108 1.79943 9.75462 2.14134 9.11561 2.75835L7.98561 3.88169"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1667 7.83335C9.87829 7.44645 9.50999 7.12608 9.08676 6.89372C8.66353 6.66136 8.19539 6.52224 7.71372 6.48585C7.23205 6.44946 6.74844 6.51644 6.29561 6.68224C5.84278 6.84804 5.43137 7.10873 5.08928 7.44669L3.08928 9.44669C2.47227 10.0857 2.13036 10.9419 2.13847 11.8313C2.14658 12.7207 2.50398 13.5704 3.13226 14.1987C3.76054 14.827 4.61031 15.1844 5.49971 15.1925C6.38911 15.2006 7.24526 14.8587 7.88428 14.2417L9.00761 13.1184"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
